import { render, staticRenderFns } from "./Kams.vue?vue&type=template&id=2d6cbb90"
import script from "./Kams.vue?vue&type=script&lang=js"
export * from "./Kams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports